module.exports = {
	"ha": "bc",
	"id": 5.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category and MSM Status, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 93.63057324840764,
						"dataLabels": {
							"enabled": false,
							"format": "147"
						},
						"color": "#043f61"
					},
					{
						"y": 88.53503184713377,
						"dataLabels": {
							"enabled": false,
							"format": "139"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.98726114649682,
						"dataLabels": {
							"enabled": false,
							"format": "135"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.52229299363057,
						"dataLabels": {
							"enabled": false,
							"format": "117"
						},
						"color": "#09472e"
					},
					{
						"y": 57.961783439490446,
						"dataLabels": {
							"enabled": false,
							"format": "91"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.03676470588235,
						"dataLabels": {
							"enabled": false,
							"format": "517"
						},
						"color": "#043f61"
					},
					{
						"y": 86.94852941176471,
						"dataLabels": {
							"enabled": false,
							"format": "473"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.63970588235294,
						"dataLabels": {
							"enabled": false,
							"format": "455"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.63235294117648,
						"dataLabels": {
							"enabled": false,
							"format": "406"
						},
						"color": "#09472e"
					},
					{
						"y": 60.29411764705882,
						"dataLabels": {
							"enabled": false,
							"format": "328"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.92387543252595,
						"dataLabels": {
							"enabled": false,
							"format": "566"
						},
						"color": "#043f61"
					},
					{
						"y": 93.42560553633218,
						"dataLabels": {
							"enabled": false,
							"format": "540"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.48442906574394,
						"dataLabels": {
							"enabled": false,
							"format": "523"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.60207612456747,
						"dataLabels": {
							"enabled": false,
							"format": "489"
						},
						"color": "#09472e"
					},
					{
						"y": 66.60899653979239,
						"dataLabels": {
							"enabled": false,
							"format": "385"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.53330504879084,
						"dataLabels": {
							"enabled": false,
							"format": "2346"
						},
						"color": "#043f61"
					},
					{
						"y": 96.902842596521,
						"dataLabels": {
							"enabled": false,
							"format": "2284"
						},
						"color": "#0c4250"
					},
					{
						"y": 94.01781926177344,
						"dataLabels": {
							"enabled": false,
							"format": "2216"
						},
						"color": "#0d4440"
					},
					{
						"y": 90.19940602460755,
						"dataLabels": {
							"enabled": false,
							"format": "2126"
						},
						"color": "#09472e"
					},
					{
						"y": 75.13788714467543,
						"dataLabels": {
							"enabled": false,
							"format": "1771"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "51"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "51"
						},
						"color": "#0c4250"
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.50980392156863,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#09472e"
					},
					{
						"y": 47.05882352941176,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.47899159663865,
						"dataLabels": {
							"enabled": false,
							"format": "232"
						},
						"color": "#043f61"
					},
					{
						"y": 94.53781512605042,
						"dataLabels": {
							"enabled": false,
							"format": "225"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.23529411764706,
						"dataLabels": {
							"enabled": false,
							"format": "210"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.94957983193278,
						"dataLabels": {
							"enabled": false,
							"format": "176"
						},
						"color": "#09472e"
					},
					{
						"y": 47.89915966386555,
						"dataLabels": {
							"enabled": false,
							"format": "114"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.59402460456941,
						"dataLabels": {
							"enabled": false,
							"format": "561"
						},
						"color": "#043f61"
					},
					{
						"y": 96.30931458699473,
						"dataLabels": {
							"enabled": false,
							"format": "548"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.91564147627417,
						"dataLabels": {
							"enabled": false,
							"format": "523"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.61335676625659,
						"dataLabels": {
							"enabled": false,
							"format": "453"
						},
						"color": "#09472e"
					},
					{
						"y": 50.26362038664324,
						"dataLabels": {
							"enabled": false,
							"format": "286"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.35666463785758,
						"dataLabels": {
							"enabled": false,
							"format": "1616"
						},
						"color": "#043f61"
					},
					{
						"y": 94.94826536822885,
						"dataLabels": {
							"enabled": false,
							"format": "1560"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.626902008521,
						"dataLabels": {
							"enabled": false,
							"format": "1489"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.29701765063908,
						"dataLabels": {
							"enabled": false,
							"format": "1385"
						},
						"color": "#09472e"
					},
					{
						"y": 60.073037127206334,
						"dataLabels": {
							"enabled": false,
							"format": "987"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 45.34412955465587,
						"dataLabels": {
							"enabled": false,
							"format": "112"
						},
						"color": "#043f61"
					},
					{
						"y": 37.65182186234818,
						"dataLabels": {
							"enabled": false,
							"format": "93"
						},
						"color": "#0c4250"
					},
					{
						"y": 34.0080971659919,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0d4440"
					},
					{
						"y": 29.1497975708502,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#09472e"
					},
					{
						"y": 18.218623481781375,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 84,
						"dataLabels": {
							"enabled": false,
							"format": "273"
						},
						"color": "#043f61"
					},
					{
						"y": 74.46153846153845,
						"dataLabels": {
							"enabled": false,
							"format": "242"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.46153846153847,
						"dataLabels": {
							"enabled": false,
							"format": "229"
						},
						"color": "#0d4440"
					},
					{
						"y": 64.3076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "209"
						},
						"color": "#09472e"
					},
					{
						"y": 46.76923076923077,
						"dataLabels": {
							"enabled": false,
							"format": "152"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 87.57485029940119,
						"dataLabels": {
							"enabled": false,
							"format": "585"
						},
						"color": "#043f61"
					},
					{
						"y": 68.11377245508982,
						"dataLabels": {
							"enabled": false,
							"format": "455"
						},
						"color": "#0c4250"
					},
					{
						"y": 64.82035928143712,
						"dataLabels": {
							"enabled": false,
							"format": "433"
						},
						"color": "#0d4440"
					},
					{
						"y": 58.83233532934131,
						"dataLabels": {
							"enabled": false,
							"format": "393"
						},
						"color": "#09472e"
					},
					{
						"y": 43.712574850299404,
						"dataLabels": {
							"enabled": false,
							"format": "292"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85.26224534026875,
						"dataLabels": {
							"enabled": false,
							"format": "1967"
						},
						"color": "#043f61"
					},
					{
						"y": 60.12136974425661,
						"dataLabels": {
							"enabled": false,
							"format": "1387"
						},
						"color": "#0c4250"
					},
					{
						"y": 57.260511486779365,
						"dataLabels": {
							"enabled": false,
							"format": "1321"
						},
						"color": "#0d4440"
					},
					{
						"y": 54.65973125270914,
						"dataLabels": {
							"enabled": false,
							"format": "1261"
						},
						"color": "#09472e"
					},
					{
						"y": 43.346337234503686,
						"dataLabels": {
							"enabled": false,
							"format": "1000"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -6.369426751592355,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.442176870748295,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.877697841726623,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.963235294117652,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.510638297872342,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8054968287526414,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.769230769230765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.21182266009852,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.076124567474047,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.59363957597173,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1481481481481444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.500956022944548,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.2678936605317,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.4666949512091678,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.6427962489343537,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.977232924693518,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.061371841155237,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.698024459078077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.833333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.8421052631579,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.5210084033613467,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.0172413793103425,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.19047619047619,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.22727272727273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.405975395430581,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.317290552584672,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.562043795620441,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.384321223709373,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.86534216335541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.6433353621424174,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4653465346534684,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.551282051282046,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.98455339153794,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.736462093862812,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -54.65587044534412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.964285714285708,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.677419354838712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -16.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.35531135531136,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.371900826446286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.733624454148469,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -12.425149700598803,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.83516483516484,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.237875288683606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.699745547073793,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -14.73775465973125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.486527707168275,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.758471521268925,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.542013626040875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.697858842188744,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=157"
			},
			{
				"x": 9,
				"text": "30-39<br>n=544"
			},
			{
				"x": 15,
				"text": "40-49<br>n=578"
			},
			{
				"x": 21,
				"text": ">=50<br>n=2357"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=51"
			},
			{
				"x": 34,
				"text": "30-39<br>n=238"
			},
			{
				"x": 40,
				"text": "40-49<br>n=569"
			},
			{
				"x": 46,
				"text": ">=50<br>n=1643"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=247"
			},
			{
				"x": 59,
				"text": "30-39<br>n=325"
			},
			{
				"x": 65,
				"text": "40-49<br>n=668"
			},
			{
				"x": 71,
				"text": ">=50<br>n=2307"
			}
		],
		"dataTable": {
			"MSM:<30": [
				157,
				147,
				139,
				135,
				117,
				91
			],
			"MSM:30-39": [
				544,
				517,
				473,
				455,
				406,
				328
			],
			"MSM:40-49": [
				578,
				566,
				540,
				523,
				489,
				385
			],
			"MSM:>=50": [
				2357,
				2346,
				2284,
				2216,
				2126,
				1771
			],
			"Non-MSM:<30": [
				51,
				51,
				51,
				48,
				38,
				24
			],
			"Non-MSM:30-39": [
				238,
				232,
				225,
				210,
				176,
				114
			],
			"Non-MSM:40-49": [
				569,
				561,
				548,
				523,
				453,
				286
			],
			"Non-MSM:>=50": [
				1643,
				1616,
				1560,
				1489,
				1385,
				987
			],
			"Unknown:<30": [
				247,
				112,
				93,
				84,
				72,
				45
			],
			"Unknown:30-39": [
				325,
				273,
				242,
				229,
				209,
				152
			],
			"Unknown:40-49": [
				668,
				585,
				455,
				433,
				393,
				292
			],
			"Unknown:>=50": [
				2307,
				1967,
				1387,
				1321,
				1261,
				1000
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_5.json
// module id = 170
// module chunks = 0